import { Navigate, useOutletContext } from 'react-router-dom';
import { Skeleton } from '@/components/ui/skeleton';
import type { AppShellContext } from '@/components/layout/AppShell';
import { HrTabs } from '@/components/hr/HrTabs';
import { MyInvoicesView } from '@/components/hr/MyInvoicesView';
import { useHrMe } from '@/components/hr/useHrData';

/** B2B self-service: "Moje faktury" — only for employees linked to a contractor. */
export function HrMyInvoicesPage() {
  const { nip } = useOutletContext<AppShellContext>();
  const { hrMe, loading } = useHrMe(nip);

  if (loading) {
    return (
      <div className="flex flex-col gap-4">
        <Skeleton className="h-9 w-64" />
        <Skeleton className="h-72 w-full" />
      </div>
    );
  }

  if (hrMe && !hrMe.employee?.hasContractor) {
    return <Navigate to={`/${nip}/hr`} replace />;
  }

  return (
    <div className="flex flex-col gap-4">
      <HrTabs nip={nip} hrMe={hrMe} />
      <MyInvoicesView nip={nip} />
    </div>
  );
}
